import { observable, flow, toJS, action } from "mobx";
import { message, notification, Modal } from "antd";
import _ from "lodash";

import {
	getSiteSelection,
	saveSiteSelection
} from "services/siteselections";
import { simpleHttpRequest } from "ag-grid";

class SiteSelectionStore {
	constructor() {
		this.ui = this.getUI();
		this.siteSelection = {
			id: 0,
			name: "",
			siteSelectionType: "Condition",
			img: false,
			video: false,
			dofollow: false,
			minPR: 0
		};			
	}

	sites = [];
	selectedSites = [];
	modules = [];

	@observable stateForm = {};

	getUI = () => {
		let ui = observable.object({
			loadingSiteSelection: true,
			savingSiteSelection: false
		});
		return ui;		
	}

	customizer = (objValue, srcValue, key, object, source, stack) => {
		if (srcValue == undefined) {
			return null;
		}
	};

	@action
	formChanged = fields => {
		_.mergeWith(this.stateForm, fields, this.customizer);
	};

	getRawObjectFromFormObject = formObject => {
		function customizer(value) {
			if (_.isObject(value)) {
				if ("value" in value) {
					return value.value;
				}
			}
		}
		let rawJS = toJS(formObject);
		return _.cloneDeepWith(rawJS, customizer);
	};

	createFormObject = siteSelection => {
		function customizer(value, key) {
			if (!_.isObject(value) && key !== "value") {
				return {
					value: value
				};
			}

			if (_.isArray(value)) {				
				return _.cloneDeep(value);				
			}
		}

		let newObj = _.cloneDeepWith(toJS(siteSelection), customizer);
		return newObj;
	};

	saveSiteSelection = flow(function*(){
		this.ui.savingSiteSelection = true;
		let siteSelection = this.getRawObjectFromFormObject(this.stateForm);

		let selectedSites = this.sites.filter(site => site.checked);
		selectedSites = selectedSites.map(selectedSite => {
			return {
				id: { 
					siteId: selectedSite.id.siteId,
					module: selectedSite.id.module 
				},
				siteSelectionId: siteSelection.id
			};
		});

		let selectedPlatforms = this.platforms.filter(platform => platform.checked);
		selectedPlatforms = selectedPlatforms.map(selectedPlatform => {
			return {
				id: { 
					platform: selectedPlatform.platform,
					module: selectedPlatform.module 
				},
				siteSelectionId: siteSelection.id,
				prob: 100
			};
		});

		let payload = {
			siteSelection: siteSelection,
			selectedSites: selectedSites,
			selectedPlatforms: selectedPlatforms
		}
		const response = yield saveSiteSelection(payload);
		this.ui.savingSiteSelection = false;

		if (response == null) {
			message.error("Failed to save site selection. Unknown error");
			return;
		}

		if (response.error) {
			message.error(response.error.message, 3);
			return;
		}

		message.success("Successfully save site selection");
		return;
	});

	loadSiteSelection = flow(function*(siteSelectionId) {
		// console.log("In loading site selection");
		this.ui = this.getUI();		
		const response = yield getSiteSelection(siteSelectionId);
		this.ui.loadingSiteSelection = false;
		// console.log("Done loading site selection");
		if (response == null) {
			message.error("Failed to get site selection. Unknown error");
			return;
		}

		if (response.error) {
			message.error(response.error.message, 3);
			return;
		}

		this.siteSelection = response.siteSelection;	

		this.sites = response.sites;
		let selectedSiteSet = new Set();

		for (let i = 0; i < response.selectedSites.length; i++) {
			let selectedSite = response.selectedSites[i];
			selectedSiteSet.add(
				selectedSite.id.module + "_" + selectedSite.id.siteId
			);
		};

		for (let i = 0; i < this.sites.length; i++) {
			let site = this.sites[i];
			if (selectedSiteSet.has(site.id.module + "_" + site.id.siteId)) {
				site.checked = true;
			}
		}		

		this.platforms = response.platforms;	
		let selectedPlatformSet = new Set();

		for (let i = 0; i < response.selectedPlatforms.length; i++) {
			let selectedPlatform = response.selectedPlatforms[i];
			selectedPlatformSet.add(
				selectedPlatform.id.module + "_" + selectedPlatform.id.platform
			);
		};

		for (let i = 0; i < this.platforms.length; i++) {
			let platform = this.platforms[i];
			if (selectedPlatformSet.has(platform.module + "_" + platform.platform)) {
				platform.checked = true;
			}
		}		
		
		this.stateForm = observable.object(this.createFormObject(this.siteSelection));
	})
}

export default SiteSelectionStore;